<div (mouseover)="interval = 2000" (mouseout)="interval = 0" class="d-flex align-items-center justify-content-between">
  <div style="z-index: 2" class="cardLoadingWrapper d-flex justify-content-center align-items-center"
       *ngIf="commercialEvent?.data.loading">
    <sb-icon class="loadingSpinnerSVG" style="font-size: 2rem" icon="loadingBlockAnimation"
             [animationOptions]="{autoplay: true, loop:true}"></sb-icon>
    <span>{{'lang.globals.pleaseWait' | translate}}</span>
  </div>
  <div #captions class="d-flex align-items-center pl-3 position-relative" style="">
    <sb-action-required [hoverStatus]="false" class="mr-3"
                        [bookingStatus]="commercialEvent?.data?.commercial?.bookingStatus"></sb-action-required>
    <sb-time-status class="mr-3" type="small" [booking]="commercialEvent?.data?.commercial"></sb-time-status>
    <sb-icon *ngIf="commercialEvent?.data?.commercial?.overwrites?.id" icon="edit" class="mr-3"></sb-icon>
    <sb-comp-image-name-wrapper
      [still]="true"
      [hoverPreview]="false"
      [customHeight]="30+'px'"
      [tooltipInterval]="interval"
      [medium]="commercialEvent?.data?.previews">
      <span firstLine>{{commercialEvent?.name}}</span>
      <span secondLine
            *ngIf="commercialEvent?.data?.commercial?.requirementCount && commercialEvent?.data?.commercial?.requirementCount > 1">
        {{commercialEvent?.data?.commercial?.requirementCount}}
        {{'lang.globals.requirements'|translate}}
      </span>
    </sb-comp-image-name-wrapper>
  </div>
  <div class="d-flex align-items-center tw-ml-8" #cullPreview>
    <sb-cull-preview class="pr-3"
                     [playerAggregationData]="commercialEvent?.data?.commercial?.playerAggregation"></sb-cull-preview>
  </div>
</div>

